import FooterCTA from "../../components/footerCTA/FooterCTA";
import Transition from "../../components/transition/Transition";
import Hero from "./hero/Hero";
import RecentProjects from "./recentProjects/RecentProjects";

export default function Home (){


    return (
        <Transition emojiName="banana">
            <Hero />

            <RecentProjects />

            <FooterCTA />

        </Transition>
    );
}